import { render } from "./post-smtp-pro-features.vue?vue&type=template&id=08b0e406&scoped=true"
import script from "./post-smtp-pro-features.vue?vue&type=script&lang=js"
export * from "./post-smtp-pro-features.vue?vue&type=script&lang=js"

import "./post-smtp-pro-features.vue?vue&type=style&index=0&id=08b0e406&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b0e406"]])

export default __exports__